// AgeGate
import { useEffect, useState } from 'react';
import { GetCookie } from '../tools/Helpers';
import { Link } from 'react-router-dom';
import { useConsent } from '../ConsentContext';

export const AgeGate = () => {
  const { consent, setConsent } = useConsent();
  const [showAgeGate, setShowAgeGate] = useState(false);
  const [showAccept, setShowAccept] = useState(true);
  const [gateError, setGateError] = useState('');
  const [fieldMessage, setFieldMessage] = useState('');

  const ValidateAge = (): void => {
    let fields: string[] = [];
    const currentYear = new Date().getFullYear();
    const ageGate = document.querySelectorAll<HTMLInputElement>('.age-gate');
    ageGate.forEach((input: HTMLInputElement) => {
      if (input.value) fields.push(input.value);
    });
    // Make sure Field is not Empty
    if (fields.length !== 0) {
      const isValidYear =
        Number.isInteger(Number(fields[2])) && Number(fields[2]) >= 1900 && Number(fields[2]) <= currentYear;
      const today = new Date();
      if (isValidYear) {
        const birthDate = new Date(Number(fields[2]), Number(fields[0]) - 1, Number(fields[1])); // Subtract 1 from month because months are zero-indexed in JavaScript
        let age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();
        const day = today.getDate() - birthDate.getDate();
        if (month < 0 || (month === 0 && day < 0)) {
          age--;
        }
        if (age < 18) {
          setFieldMessage('');
          setGateError("Sorry, but you're not permitted to view these materials at this time.");
          document.cookie = `agegate_allow=failed; path=/; max-age=3600`;
        } else {
          setFieldMessage('');
          setGateError('');
          setShowAgeGate(false);
          document.cookie = `agegate_allow=passed; path=/; max-age=31536000`;
          document.body.setAttribute('style', 'overflow:inherit;');
        }
      } else {
        setGateError('');
        setFieldMessage('Invalid Input. These fields are required.');
      }
    } else {
      setGateError('');
      setFieldMessage('Invalid Input. These fields are required.');
    }
  };

  const handleDecline = () => {
    setShowAccept(false);
    setConsent('decline');
  };

  useEffect(() => {
    if (consent !== 'decline') {
      // Allow AgeGate
      if (!GetCookie('agegate_allow')) {
        document.body.setAttribute('style', 'overflow:hidden;');
        window.scrollTo(0, 0);
        setShowAgeGate(true);
      } else if (GetCookie('agegate_allow') === 'failed') {
        document.body.setAttribute('style', 'overflow:hidden;');
        window.scrollTo(0, 0);
        setShowAgeGate(true);
        setGateError("Sorry, but you're not permitted to view these materials at this time.");
      } else {
        setShowAgeGate(false);
      }
    } else {
      document.cookie = `agegate_allow=; Max-Age=0; path=/; domain=${window.location.hostname};`;
      document.body.setAttribute('style', 'overflow:hidden;');
      window.scrollTo(0, 0);
      setShowAgeGate(true);
    }
  }, [consent]);

  return (
    <>
      {showAgeGate && (
        <section id="agegate">
          <div className="h-100 d-flex justify-content-center align-items-center">
            <div className="wrapper">
              {gateError === '' && consent !== 'decline' ? (
                <h3 className="title mb-4 mt-3 muted">Please, enter your birthdate.</h3>
              ) : (
                ''
              )}
              <form>
                {gateError === '' && consent !== 'decline' ? (
                  <div className="form-group d-flex justify-content-between">
                    <input
                      type="number"
                      inputMode="numeric"
                      pattern="[0-9]{2}"
                      name="MM"
                      placeholder="MM"
                      min="01"
                      max="12"
                      maxLength={2}
                      className="form-control age-gate"
                      required
                    />
                    <input
                      type="number"
                      inputMode="numeric"
                      pattern="[0-9]{3}"
                      name="DD"
                      placeholder="DD"
                      min="01"
                      max="31"
                      maxLength={2}
                      className="form-control age-gate"
                      required
                    />
                    <input
                      type="number"
                      inputMode="numeric"
                      pattern="[0-9]{3}"
                      name="YYYY"
                      placeholder="YYYY"
                      max="9999"
                      maxLength={4}
                      className="form-control age-gate"
                      required
                    />
                  </div>
                ) : (
                  ''
                )}
                {fieldMessage && <div className="alert alert-danger">{fieldMessage}</div>}
                {gateError && <div className="alert alert-danger">{gateError}</div>}
                {gateError === '' && consent !== 'decline' ? (
                  <>
                    <button type="button" className="btn btn-shape" onClick={ValidateAge}>
                      Enter
                    </button>
                  </>
                ) : (
                  ''
                )}
              </form>
              {consent === 'decline' && (
                <div id="cookie-gate" className="text-center">
                  <div>
                    We use cookies to improve your experience and analyze site traffic. You can decline of the use of
                    cookies for analytics and tracking purposes. We do not sell your personal information.{' '}
                    <span>
                      Please review our{' '}
                      <Link className="underline" to={'/privacy-policy/'}>
                        Privacy Policy
                      </Link>
                      .
                    </span>
                  </div>
                  {showAccept && (
                    <div className="d-flex align-items-center justify-content-center mt-3">
                      <Link className="btn-theme" onClick={() => setConsent('accept')} to={'#'}>
                        Accept
                      </Link>
                      <Link className="btn-theme ms-2" onClick={handleDecline} to={'#'}>
                        Decline
                      </Link>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </section>
      )}
    </>
  );
};
